
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum HubAction {
	Insert = 0,
	Update = 1,
	Delete = 2
}
export namespace HubAction {
	export function getKeys(): Map<HubAction, string> {
		return new Map([[0, 'Insert'], [1, 'Update'], [2, 'Delete']]);
	}
}
